module.exports = __webpack_public_path__ + "static/feature-phone-4-51ff17527b7e6c56422af1ee3df8aa6a.png";